var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { documentFormatter } from "../../App/utils/formatter";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import "../styles/SubscribersList.css";
import "../../App/styles/GlobalStyle.css";
import FilterAltOffRoundedIcon from "@mui/icons-material/FilterAltOffRounded";
import { Tooltip, Select, MenuItem } from "@mui/material";
import { PriorityHigh } from "@mui/icons-material";
import MuiIcon from "../../App/components/MuiIcon";
import { getTokenStatusConfig } from "../../App/utils/tokenStatusUtils";
import { setClarityTag } from "../../App/utils/clarity";
import useAuth from "../../App/hooks/useAuth";
function computeServiceRows(services, subscriberId, serviceWidths, containerWidth) {
    var rows = [];
    var curRow = [];
    var curRowW = 0;
    var gap = 5;
    services.forEach(function (_, idx) {
        var hw = serviceWidths["".concat(subscriberId, "-").concat(idx)] || 0;
        var addW = curRow.length === 0 ? hw : hw + gap;
        if (hw === 0 || curRow.length === 0 || curRowW + addW <= containerWidth) {
            curRow.push(idx);
            curRowW += addW;
        }
        else {
            rows.push(__spreadArray([], curRow, true));
            curRow = [idx];
            curRowW = hw;
        }
    });
    if (curRow.length > 0)
        rows.push(curRow);
    return rows;
}
function getContrastColor(backgroundColor) {
    var hex = backgroundColor.replace("#", "");
    var r = Number.parseInt(hex.substring(0, 2), 16) / 255;
    var g = Number.parseInt(hex.substring(2, 4), 16) / 255;
    var b = Number.parseInt(hex.substring(4, 6), 16) / 255;
    var luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
}
function EmailStatusIcon(_a) {
    var hasFailed = _a.hasFailed;
    return (_jsx(Tooltip, __assign({ title: hasFailed ? "Erro" : "Enviado", placement: "top", arrow: true }, { children: _jsx("span", { children: _jsx(MuiIcon, { iconName: hasFailed ? "MarkEmailUnreadOutlined" : "MarkEmailReadOutlined", iconColor: hasFailed ? "#F24C4C" : "#388E3C" }) }) })));
}
function ServiceBadge(_a) {
    var item = _a.item, isHovered = _a.isHovered, maxWidth = _a.maxWidth, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, setMeasureRef = _a.setMeasureRef, onFixError = _a.onFixError;
    var statusCfg = getTokenStatusConfig(item.status);
    return (_jsxs("div", __assign({ style: { position: "relative", display: "inline-flex" }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: [_jsxs("div", __assign({ ref: setMeasureRef, style: {
                    position: "absolute",
                    visibility: "hidden",
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "5px 12px",
                    whiteSpace: "nowrap",
                } }, { children: [_jsx("div", __assign({ style: { padding: "2px 8px", borderRadius: "100px", fontSize: "0.6875rem" } }, { children: item.token_status_translation })), _jsx("span", __assign({ style: { fontSize: "0.7rem" } }, { children: item.content_supplier_product_name }))] })), _jsx("div", __assign({ className: item.has_error
                    ? "service-block service_with_error"
                    : "service-block service-item", style: __assign({ backgroundColor: statusCfg.backgroundColor }, (isHovered && { maxWidth: maxWidth, overflow: "hidden" })) }, { children: isHovered ? (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "service-name-status", style: {
                                backgroundColor: statusCfg.iconColor,
                                color: getContrastColor(statusCfg.iconColor || "#000000"),
                            } }, { children: item.token_status_translation })), _jsx("span", __assign({ className: "service-name", style: { flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" } }, { children: item.content_supplier_product_name }))] })) : (_jsxs(_Fragment, { children: [_jsx(MuiIcon, { iconName: statusCfg.iconName, iconColor: statusCfg.iconColor }), _jsx("span", __assign({ className: "service-name" }, { children: item.content_supplier_product_name }))] })) })), item.has_error === 1 && (_jsx("button", __assign({ type: "button", className: "fix-error-action-button button", onClick: function (event) {
                    event.stopPropagation();
                    onFixError(item.content_supplier_product_id, item.status_id);
                } }, { children: _jsx(PriorityHigh, { className: "error-icon" }) })))] })));
}
var SubscribersList = function (props) {
    var navigate = useNavigate();
    var auth = useAuth().auth;
    var canViewSubscriber = auth.permissions.includes("view-subscriber");
    var _a = useState(null), hoveredService = _a[0], setHoveredService = _a[1];
    var _b = useState(null), expandedRow = _b[0], setExpandedRow = _b[1];
    var _c = useState(window.innerWidth <= 768), isMobile = _c[0], setIsMobile = _c[1];
    var _d = useState("search"), view = _d[0], setView = _d[1];
    var _e = useState(null), selectedSub = _e[0], setSelectedSub = _e[1];
    var _f = useState({}), serviceWidths = _f[0], setServiceWidths = _f[1];
    var serviceRefs = React.useRef({});
    var _g = useState(400), containerWidth = _g[0], setContainerWidth = _g[1];
    var containerRef = React.useRef(null);
    React.useEffect(function () {
        var widths = {};
        Object.entries(serviceRefs.current).forEach(function (_a) {
            var key = _a[0], ref = _a[1];
            if (ref)
                widths[key] = ref.offsetWidth;
        });
        setServiceWidths(widths);
        if (containerRef.current) {
            var styles = getComputedStyle(containerRef.current);
            var hPad = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
            setContainerWidth(containerRef.current.offsetWidth - hPad);
        }
    }, [props.subscribersList]);
    useEffect(function () {
        if (props.searchingTerm === "") {
            setView("search");
            setSelectedSub(null);
            if (props.onViewChange)
                props.onViewChange("search");
        }
    }, [props.searchingTerm, props.onViewChange]);
    useEffect(function () {
        var handleResize = function () { return setIsMobile(window.innerWidth <= 768); };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, []);
    var handleExpandRow = function (id) {
        setClarityTag("actionType", "subscribers-expand-row-click");
        setExpandedRow(expandedRow === id ? null : id);
    };
    function editSubscriber(subscriberData, contentSuppliersProducts, tab, contentSupplierId) {
        if (isMobile) {
            setSelectedSub(subscriberData);
            setView("details");
            props.callbackCheckboxSubscriber(subscriberData.document);
            if (props.onViewChange)
                props.onViewChange("details");
            return;
        }
        navigate("/subscribers/".concat(subscriberData.id, "/update"), {
            state: {
                subscriber: {
                    id: subscriberData.id,
                    name: subscriberData.name,
                    email: subscriberData.email,
                    document: subscriberData.document,
                    phone: subscriberData.phone,
                    internet_speed_id: subscriberData.internet_speed_id,
                    customer_plan: subscriberData.customer_plan,
                    customer_id: subscriberData.customer_id,
                    services: subscriberData.services,
                },
                services: subscriberData.services,
                contentSupplierId: contentSupplierId,
                contentSuppliers: props.contentSuppliers,
                subscriberNameReport: subscriberData.name,
            },
        });
    }
    if (isMobile) {
        if (view === "details" && selectedSub) {
            return (_jsxs("div", __assign({ className: "mobile-details-page" }, { children: [_jsx("h2", __assign({ className: "details-title-name" }, { children: selectedSub.name })), _jsxs("div", __assign({ className: "details-table-container" }, { children: [_jsxs("div", __assign({ className: "details-table-header" }, { children: [_jsx("span", { children: "PRODUTOS" }), _jsx("span", { children: "STATUS" })] })), selectedSub.services.map(function (service, index) {
                                var statusConfig = getTokenStatusConfig(service.status);
                                return (_jsxs("div", __assign({ className: "details-service-row" }, { children: [_jsx("span", { children: service.content_supplier_product_name }), _jsx("span", __assign({ className: "status-tag", style: {
                                                backgroundColor: statusConfig.backgroundColor,
                                                color: statusConfig.iconColor ||
                                                    "#000",
                                                padding: "4px 12px",
                                                borderRadius: "100px",
                                                fontSize: "12px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                textTransform: "capitalize",
                                            } }, { children: service.token_status_translation }))] }), index));
                            })] })), props.mobileActionsSlot && (_jsx("div", __assign({ className: "mobile-actions-footer" }, { children: props.mobileActionsSlot })))] })));
        }
        return (_jsx("div", __assign({ className: "mobile-search-view" }, { children: props.searchingTerm.length > 0 && props.subscribersList.length > 0 ? (_jsxs("table", __assign({ className: "mobile-search-table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "NOME" }), _jsx("th", { children: "EMAIL" })] }) }), _jsx("tbody", { children: props.subscribersList.map(function (sub) {
                            var term = props.searchingTerm.toLowerCase();
                            var name = sub.name;
                            var index = name.toLowerCase().indexOf(term);
                            var displayName = name;
                            if (index !== -1 && term !== "") {
                                displayName = (_jsxs(_Fragment, { children: [name.substring(0, index), _jsx("span", __assign({ className: "highlight-text" }, { children: name.substring(index, index + term.length) })), name.substring(index + term.length)] }));
                            }
                            return (_jsxs("tr", __assign({ onClick: function () {
                                    setSelectedSub(sub);
                                    setView("details");
                                    props.callbackCheckboxSubscriber(sub.document);
                                    if (props.onViewChange)
                                        props.onViewChange("details");
                                } }, { children: [_jsx("td", __assign({ className: "clickable-cell" }, { children: displayName })), _jsx("td", __assign({ className: "text-muted clickable-cell" }, { children: sub.email }))] }), sub.id));
                        }) })] }))) : props.searchingTerm.length > 0 && props.subscribersList.length === 0 ? (_jsx("div", __assign({ className: "mobile-no-results" }, { children: "Nenhum assinante encontrado" }))) : null })));
    }
    return (_jsx("div", { children: _jsxs("table", __assign({ className: "default-table-styling" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "Nome" }), _jsx("th", { children: "Envio" }), _jsx("th", { children: "E-mail" }), _jsx("th", __assign({ className: props.serviceValue !== 0
                                    ? "column-filtered"
                                    : "", style: {
                                    width: "450px",
                                    marginBottom: props.serviceValue !== 0
                                        ? "1.4rem"
                                        : "16px",
                                } }, { children: _jsxs("div", __assign({ style: {
                                        display: "flex",
                                        position: "relative",
                                    } }, { children: [_jsx(Select, __assign({ value: props.serviceValue, displayEmpty: true, variant: "standard", disableUnderline: true, onChange: function (e) {
                                                props.callbackFilterService({
                                                    target: { value: e.target.value },
                                                });
                                            }, renderValue: function (selected) {
                                                var _a, _b;
                                                if (selected === 0) {
                                                    return _jsx("span", __assign({ style: { fontWeight: "bold" } }, { children: "Produtos" }));
                                                }
                                                var product = (_a = props.contentSupplierProductsList) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.id === selected; });
                                                return _jsx("span", __assign({ style: { fontWeight: "bold" } }, { children: (_b = product === null || product === void 0 ? void 0 : product.name) !== null && _b !== void 0 ? _b : "Produtos" }));
                                            }, sx: {
                                                fontWeight: "bold",
                                                fontSize: "inherit",
                                                color: props.serviceValue !== 0 ? "#fff" : "inherit",
                                                minWidth: 120,
                                                "& .MuiSelect-icon": {
                                                    color: props.serviceValue !== 0 ? "#fff" : "inherit",
                                                },
                                            } }, { children: props.contentSupplierProductsList && props.contentSupplierProductsList.length > 0 ? (props.contentSupplierProductsList.map(function (item, index) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.name }), index)); })) : (_jsx(MenuItem, __assign({ disabled: true }, { children: "Nenhum cadastrado" }))) })), props.qtyErrors !== 0 && (_jsx("div", __assign({ className: "qty-errors" }, { children: _jsxs("span", __assign({ onClick: function () {
                                                    return props.callbackFilterError();
                                                } }, { children: [_jsx("b", { children: props.qtyErrors }), " ERROS"] })) })))] })) })), _jsx("th", { children: "CPF" }), _jsx("th", { children: "Telefone" }), _jsx("th", { children: _jsx(Tooltip, __assign({ title: "Limpar filtros", placement: "top", arrow: true }, { children: _jsx("button", __assign({ onClick: function () { return props.callbackFilterClear(); }, type: "button", className: "button-filter-clear" }, { children: _jsx(FilterAltOffRoundedIcon, {}) })) })) })] }) }), _jsx("tbody", { children: props.subscribersList.length > 0 ? (props.subscribersList.map(function (subscriber) {
                        var _a, _b;
                        var serviceRows = computeServiceRows((_a = subscriber.services) !== null && _a !== void 0 ? _a : [], subscriber.id, serviceWidths, containerWidth);
                        var handleRowClick = canViewSubscriber
                            ? function () {
                                return editSubscriber(subscriber, props.contentSupplierProductsList, "updateSubscriber", props.contentSupplierId);
                            }
                            : undefined;
                        var clickableCellClass = canViewSubscriber ? "clickable-cell" : "";
                        var servicesCellClass = "container-services-subscriber".concat(canViewSubscriber ? " clickable-cell" : "");
                        return (_jsxs("tr", { children: [_jsx("td", __assign({ className: "subscriber-checkbox clickable-cell", onClick: function (e) { return e.stopPropagation(); } }, { children: _jsx("div", __assign({ className: "container-input-check-subscriber" }, { children: _jsx("input", { type: "checkbox", checked: props.selectedData.includes(subscriber.document), name: "subscriber", value: subscriber.document, onChange: function () {
                                                return props.callbackCheckboxSubscriber(subscriber.document);
                                            }, className: "input-check-subscriber" }) })) })), _jsx(Tooltip, __assign({ title: subscriber.name, placement: "top", arrow: true }, { children: _jsx("td", __assign({ className: clickableCellClass, style: {
                                            maxWidth: "250px",
                                        }, onClick: handleRowClick }, { children: subscriber.name })) })), _jsx("td", __assign({ className: clickableCellClass, style: { textAlign: "center" }, onClick: handleRowClick }, { children: _jsx(EmailStatusIcon, { hasFailed: subscriber.has_failed_email }) })), _jsx(Tooltip, __assign({ title: subscriber.email, placement: "top", arrow: true }, { children: _jsx("td", __assign({ className: clickableCellClass, style: {
                                            maxWidth: "250px",
                                        }, onClick: handleRowClick }, { children: subscriber.email })) })), _jsx("td", __assign({ ref: function (el) { containerRef.current = el; }, onClick: handleRowClick, style: props.serviceValue === 0
                                        ? {}
                                        : {
                                            backgroundColor: "rgba(234, 90, 28, .1)",
                                            minWidth: "400px",
                                        }, className: servicesCellClass }, { children: ((_b = subscriber.services) !== null && _b !== void 0 ? _b : []).length === 0 ? (_jsx("p", __assign({ style: { marginTop: "0.5rem" } }, { children: "Nenhum servi\u00E7o" }))) : (_jsx(_Fragment, { children: serviceRows.map(function (rowIndices, rowIdx) { return (_jsx("div", __assign({ style: {
                                                display: "flex",
                                                flexWrap: "nowrap",
                                                gap: "5px",
                                                marginBottom: "4px",
                                            } }, { children: rowIndices.map(function (idx) {
                                                var item = subscriber.services[idx];
                                                var itemKey = "".concat(subscriber.id, "-").concat(idx);
                                                return (_jsx(ServiceBadge, { item: item, isHovered: hoveredService === itemKey, maxWidth: Math.min(serviceWidths[itemKey] || containerWidth, containerWidth), onMouseEnter: function () { return setHoveredService(itemKey); }, onMouseLeave: function () { return setHoveredService(null); }, setMeasureRef: function (el) {
                                                        serviceRefs.current[itemKey] = el;
                                                    }, onFixError: function (productId, statusId) {
                                                        return props.callbackFixErrorAction(subscriber.document, productId, statusId);
                                                    } }, idx));
                                            }) }), rowIdx)); }) })) })), _jsx("td", __assign({ className: clickableCellClass, onClick: handleRowClick }, { children: documentFormatter(subscriber.document) })), _jsx("td", __assign({ className: clickableCellClass, onClick: handleRowClick }, { children: formatPhoneNumberIntl(subscriber.phone) })), _jsx("td", __assign({ className: "clickable-cell" }, { children: _jsx("button", { onClick: function (e) {
                                            e.stopPropagation();
                                            handleExpandRow(subscriber.id);
                                        }, style: {
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            marginLeft: "8px",
                                        } }) }))] }, subscriber.id));
                    })) : (_jsx("tr", { children: _jsx("td", __assign({ colSpan: 7 }, { children: props.searchingTerm !== ""
                                ? "Nenhum assinante encontrado"
                                : "Nenhum assinante cadastrado" })) })) })] })) }));
};
export default SubscribersList;
